export const DOCK_MARGIN = 14;
export const DOCK_COLLAPSED_H = 72;
export const SEAM_H = 16;
export const DEFAULT_LUMEN_FRAC = 1 / 3;
export const MAX_LUMEN_FRAC = 0.5;
export const COLLAPSE_SNAP = 28;

export const HOTSPOT_LABELS = {
  whiteboard: "Whiteboard",
  desk: "Desk",
  bookshelf: "Bookshelf",
  calendar: "Calendar",
  bulletin_board: "Bulletin Board",
  couch: "Couch",
  painting: "Painting",
};

export const HOTSPOT_PROMPT_CHIPS = {
  desk: [
    { id: "desk-draft", label: "Help me start a draft", send: "Help me start a draft on the desk" },
    { id: "desk-tighten", label: "Tighten this document", send: "Tighten the document on my desk" },
    { id: "desk-checklist", label: "Turn it into a checklist", send: "Turn the document on my desk into a checklist" },
  ],
  bookshelf: [
    { id: "shelf-find", label: "Find something I saved", send: "Help me find something on my bookshelf" },
    { id: "shelf-summary", label: "Summarize a saved doc", send: "Summarize something on my bookshelf" },
  ],
  calendar: [
    { id: "cal-plan", label: "Plan my day", send: "Help me plan my day" },
    { id: "cal-next", label: "What's coming up?", send: "What's coming up on my calendar?" },
  ],
  bulletin_board: [
    { id: "board-actions", label: "Add action items", send: "Add action items to my bulletin board" },
    { id: "board-open", label: "What's still open?", send: "What's still open on my bulletin board?" },
  ],
  couch: [
    { id: "couch-unwind", label: "Help me unwind", send: "Help me unwind" },
    { id: "couch-breathe", label: "Breathe with me", send: "Breathe with me for a minute" },
  ],
  painting: [
    { id: "painting-what", label: "What is this space for?", send: "What is this painting space for?" },
  ],
};

export function clampLumenFrac(frac) {
  const f = Number(frac);
  if (!Number.isFinite(f)) return DEFAULT_LUMEN_FRAC;
  return Math.max(0, Math.min(MAX_LUMEN_FRAC, f));
}

/** Split key for the dock when no hotspot is open. */
export const FREE_DOCK_KEY = "room";

function splitHeight(avail, open, frac) {
  const wanted = open ? avail * clampLumenFrac(frac) : DOCK_COLLAPSED_H;
  const cap = Math.max(DOCK_COLLAPSED_H, avail * MAX_LUMEN_FRAC);
  return Math.round(Math.max(DOCK_COLLAPSED_H, Math.min(cap, wanted)));
}

export function dockGeometry({ viewportW, viewportH, topInset, hotspot, open, frac }) {
  const top = hotspot ? hotspot.top : topInset;
  const avail = Math.max(0, viewportH - top - DOCK_MARGIN - SEAM_H);
  const height = splitHeight(avail, open, frac);

  let left, right;
  if (hotspot) {
    ({ left, right } = hotspot);
  } else {
    const width = Math.max(0, Math.min(960, viewportW - DOCK_MARGIN * 2, Math.max(560, viewportW * 0.62)));
    left = right = Math.round((viewportW - width) / 2);
  }

  return {
    dock: { left, right, bottom: DOCK_MARGIN, height },
    seam: { left, right, bottom: DOCK_MARGIN + height, height: SEAM_H },
    hotspotBottom: hotspot ? DOCK_MARGIN + height + SEAM_H : null,
    avail,
  };
}

const splitKey = (userId, hotspot) => `nq:lumen-split:${userId || "anon"}:${hotspot}`;

export function loadLumenSplit(userId, hotspot) {
  try {
    const raw = window.localStorage.getItem(splitKey(userId, hotspot));
    if (raw === null) return DEFAULT_LUMEN_FRAC;
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? clampLumenFrac(value) : DEFAULT_LUMEN_FRAC;
  } catch {
    return DEFAULT_LUMEN_FRAC;
  }
}

export function saveLumenSplit(userId, hotspot, frac) {
  try {
    window.localStorage.setItem(splitKey(userId, hotspot), String(clampLumenFrac(frac)));
  } catch {
    return;
  }
}
